import { render, staticRenderFns } from "./SQLReports.vue?vue&type=template&id=15a5ad68&"
import script from "./SQLReports.vue?vue&type=script&lang=js&"
export * from "./SQLReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports